/**
 * #moderation_svc.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { Empty } from "../../../../google/protobuf/empty.js";
import { StringValue } from "../../../../google/protobuf/wrappers.js";
import { JsonRedditObjects, JsonStatus, Listing } from "../common/common_msg.js";
import { AboutLocationRequest, AboutLogRequest, AboutLogResponse, AcceptModeratorInviteRequest, BasicModerationIdRequest, DistinguishRequest, FilterRequest, RemoveRequest, SnoozeReportsRequest, StylesheetRequest, UpdateCrowdControlLevelRequest, } from "./moderation_msg.js";
export const ModerationServiceName = "devvit.plugin.redditapi.moderation.Moderation";
export class ModerationClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || ModerationServiceName;
        this.rpc = rpc;
        this.AboutLog = this.AboutLog.bind(this);
        this.AboutLocation = this.AboutLocation.bind(this);
        this.AboutReports = this.AboutReports.bind(this);
        this.AboutSpam = this.AboutSpam.bind(this);
        this.AboutModqueue = this.AboutModqueue.bind(this);
        this.AboutUnmoderated = this.AboutUnmoderated.bind(this);
        this.AboutEdited = this.AboutEdited.bind(this);
        this.AcceptModeratorInvite = this.AcceptModeratorInvite.bind(this);
        this.Approve = this.Approve.bind(this);
        this.Distinguish = this.Distinguish.bind(this);
        this.IgnoreReports = this.IgnoreReports.bind(this);
        this.LeaveContributor = this.LeaveContributor.bind(this);
        this.LeaveModerator = this.LeaveModerator.bind(this);
        this.MuteMessageAuthor = this.MuteMessageAuthor.bind(this);
        this.Remove = this.Remove.bind(this);
        this.Filter = this.Filter.bind(this);
        this.ShowComment = this.ShowComment.bind(this);
        this.SnoozeReports = this.SnoozeReports.bind(this);
        this.UnignoreReports = this.UnignoreReports.bind(this);
        this.UnmuteMessageAuthor = this.UnmuteMessageAuthor.bind(this);
        this.UnsnoozeReports = this.UnsnoozeReports.bind(this);
        this.UpdateCrowdControlLevel = this.UpdateCrowdControlLevel.bind(this);
        this.Stylesheet = this.Stylesheet.bind(this);
    }
    AboutLog(request, metadata) {
        const data = AboutLogRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "AboutLog", data, metadata);
        return promise.then((data) => AboutLogResponse.decode(_m0.Reader.create(data)));
    }
    AboutLocation(request, metadata) {
        const data = AboutLocationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "AboutLocation", data, metadata);
        return promise.then((data) => Listing.decode(_m0.Reader.create(data)));
    }
    AboutReports(request, metadata) {
        const data = AboutLocationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "AboutReports", data, metadata);
        return promise.then((data) => Listing.decode(_m0.Reader.create(data)));
    }
    AboutSpam(request, metadata) {
        const data = AboutLocationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "AboutSpam", data, metadata);
        return promise.then((data) => Listing.decode(_m0.Reader.create(data)));
    }
    AboutModqueue(request, metadata) {
        const data = AboutLocationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "AboutModqueue", data, metadata);
        return promise.then((data) => Listing.decode(_m0.Reader.create(data)));
    }
    AboutUnmoderated(request, metadata) {
        const data = AboutLocationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "AboutUnmoderated", data, metadata);
        return promise.then((data) => Listing.decode(_m0.Reader.create(data)));
    }
    AboutEdited(request, metadata) {
        const data = AboutLocationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "AboutEdited", data, metadata);
        return promise.then((data) => Listing.decode(_m0.Reader.create(data)));
    }
    AcceptModeratorInvite(request, metadata) {
        const data = AcceptModeratorInviteRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "AcceptModeratorInvite", data, metadata);
        return promise.then((data) => JsonStatus.decode(_m0.Reader.create(data)));
    }
    Approve(request, metadata) {
        const data = BasicModerationIdRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Approve", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    Distinguish(request, metadata) {
        const data = DistinguishRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Distinguish", data, metadata);
        return promise.then((data) => JsonRedditObjects.decode(_m0.Reader.create(data)));
    }
    IgnoreReports(request, metadata) {
        const data = BasicModerationIdRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "IgnoreReports", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    LeaveContributor(request, metadata) {
        const data = BasicModerationIdRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "LeaveContributor", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    LeaveModerator(request, metadata) {
        const data = BasicModerationIdRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "LeaveModerator", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    MuteMessageAuthor(request, metadata) {
        const data = BasicModerationIdRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "MuteMessageAuthor", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    Remove(request, metadata) {
        const data = RemoveRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Remove", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    Filter(request, metadata) {
        const data = FilterRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Filter", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    ShowComment(request, metadata) {
        const data = BasicModerationIdRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "ShowComment", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    SnoozeReports(request, metadata) {
        const data = SnoozeReportsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SnoozeReports", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    UnignoreReports(request, metadata) {
        const data = BasicModerationIdRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UnignoreReports", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    UnmuteMessageAuthor(request, metadata) {
        const data = BasicModerationIdRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UnmuteMessageAuthor", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    UnsnoozeReports(request, metadata) {
        const data = SnoozeReportsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UnsnoozeReports", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    UpdateCrowdControlLevel(request, metadata) {
        const data = UpdateCrowdControlLevelRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UpdateCrowdControlLevel", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    Stylesheet(request, metadata) {
        const data = StylesheetRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Stylesheet", data, metadata);
        return promise.then((data) => StringValue.decode(_m0.Reader.create(data)));
    }
}
export const ModerationDefinition = {
    name: "Moderation",
    fullName: "devvit.plugin.redditapi.moderation.Moderation",
    methods: {
        /** https://www.reddit.com/dev/api#GET_about_log */
        aboutLog: {
            name: "AboutLog",
            requestType: AboutLogRequest,
            requestStream: false,
            responseType: AboutLogResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            118,
                            18,
                            116,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            98,
                            111,
                            117,
                            116,
                            47,
                            108,
                            111,
                            103,
                            63,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                            38,
                            109,
                            111,
                            100,
                            61,
                            123,
                            109,
                            111,
                            100,
                            125,
                            38,
                            116,
                            121,
                            112,
                            101,
                            61,
                            123,
                            116,
                            121,
                            112,
                            101,
                            125,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_about_\{location\} */
        aboutLocation: {
            name: "AboutLocation",
            requestType: AboutLocationRequest,
            requestStream: false,
            responseType: Listing,
            responseStream: false,
            options: {},
        },
        /** https://www.reddit.com/dev/api#GET_about_\reports */
        aboutReports: {
            name: "AboutReports",
            requestType: AboutLocationRequest,
            requestStream: false,
            responseType: Listing,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            112,
                            18,
                            110,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            98,
                            111,
                            117,
                            116,
                            47,
                            114,
                            101,
                            112,
                            111,
                            114,
                            116,
                            115,
                            63,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                            38,
                            111,
                            110,
                            108,
                            121,
                            61,
                            123,
                            111,
                            110,
                            108,
                            121,
                            125,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_about_\spam */
        aboutSpam: {
            name: "AboutSpam",
            requestType: AboutLocationRequest,
            requestStream: false,
            responseType: Listing,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            109,
                            18,
                            107,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            98,
                            111,
                            117,
                            116,
                            47,
                            115,
                            112,
                            97,
                            109,
                            63,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                            38,
                            111,
                            110,
                            108,
                            121,
                            61,
                            123,
                            111,
                            110,
                            108,
                            121,
                            125,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_about_\modqueue */
        aboutModqueue: {
            name: "AboutModqueue",
            requestType: AboutLocationRequest,
            requestStream: false,
            responseType: Listing,
            responseStream: false,
            options: {},
        },
        /** https://www.reddit.com/dev/api#GET_about_\unmoderated */
        aboutUnmoderated: {
            name: "AboutUnmoderated",
            requestType: AboutLocationRequest,
            requestStream: false,
            responseType: Listing,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            116,
                            18,
                            114,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            98,
                            111,
                            117,
                            116,
                            47,
                            117,
                            110,
                            109,
                            111,
                            100,
                            101,
                            114,
                            97,
                            116,
                            101,
                            100,
                            63,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                            38,
                            111,
                            110,
                            108,
                            121,
                            61,
                            123,
                            111,
                            110,
                            108,
                            121,
                            125,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_about_\edited */
        aboutEdited: {
            name: "AboutEdited",
            requestType: AboutLocationRequest,
            requestStream: false,
            responseType: Listing,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            111,
                            18,
                            109,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            98,
                            111,
                            117,
                            116,
                            47,
                            101,
                            100,
                            105,
                            116,
                            101,
                            100,
                            63,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                            38,
                            111,
                            110,
                            108,
                            121,
                            61,
                            123,
                            111,
                            110,
                            108,
                            121,
                            125,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_accept_moderator_invite */
        acceptModeratorInvite: {
            name: "AcceptModeratorInvite",
            requestType: AcceptModeratorInviteRequest,
            requestStream: false,
            responseType: JsonStatus,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            44,
                            18,
                            42,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            97,
                            99,
                            99,
                            101,
                            112,
                            116,
                            95,
                            109,
                            111,
                            100,
                            101,
                            114,
                            97,
                            116,
                            111,
                            114,
                            95,
                            105,
                            110,
                            118,
                            105,
                            116,
                            101,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_approve */
        approve: {
            name: "Approve",
            requestType: BasicModerationIdRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([14, 18, 12, 47, 97, 112, 105, 47, 97, 112, 112, 114, 111, 118, 101]),
                        new Uint8Array([2, 24, 3]),
                        new Uint8Array([4, 50, 2, 105, 100]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_distinguish */
        distinguish: {
            name: "Distinguish",
            requestType: DistinguishRequest,
            requestStream: false,
            responseType: JsonRedditObjects,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([18, 18, 16, 47, 97, 112, 105, 47, 100, 105, 115, 116, 105, 110, 103, 117, 105, 115, 104]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([2, 32, 1]),
                        new Uint8Array([4, 50, 2, 105, 100]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_ignore_reports */
        ignoreReports: {
            name: "IgnoreReports",
            requestType: BasicModerationIdRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            21,
                            18,
                            19,
                            47,
                            97,
                            112,
                            105,
                            47,
                            105,
                            103,
                            110,
                            111,
                            114,
                            101,
                            95,
                            114,
                            101,
                            112,
                            111,
                            114,
                            116,
                            115,
                        ]),
                        new Uint8Array([2, 24, 3]),
                        new Uint8Array([4, 50, 2, 105, 100]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_leavecontributor */
        leaveContributor: {
            name: "LeaveContributor",
            requestType: BasicModerationIdRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            23,
                            18,
                            21,
                            47,
                            97,
                            112,
                            105,
                            47,
                            108,
                            101,
                            97,
                            118,
                            101,
                            99,
                            111,
                            110,
                            116,
                            114,
                            105,
                            98,
                            117,
                            116,
                            111,
                            114,
                        ]),
                        new Uint8Array([2, 24, 3]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_leavemoderator */
        leaveModerator: {
            name: "LeaveModerator",
            requestType: BasicModerationIdRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            21,
                            18,
                            19,
                            47,
                            97,
                            112,
                            105,
                            47,
                            108,
                            101,
                            97,
                            118,
                            101,
                            109,
                            111,
                            100,
                            101,
                            114,
                            97,
                            116,
                            111,
                            114,
                        ]),
                        new Uint8Array([2, 24, 3]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_mute_message_author */
        muteMessageAuthor: {
            name: "MuteMessageAuthor",
            requestType: BasicModerationIdRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            26,
                            18,
                            24,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            117,
                            116,
                            101,
                            95,
                            109,
                            101,
                            115,
                            115,
                            97,
                            103,
                            101,
                            95,
                            97,
                            117,
                            116,
                            104,
                            111,
                            114,
                        ]),
                        new Uint8Array([2, 24, 3]),
                        new Uint8Array([4, 50, 2, 105, 100]),
                        new Uint8Array([2, 88, 1]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_remove */
        remove: {
            name: "Remove",
            requestType: RemoveRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([13, 18, 11, 47, 97, 112, 105, 47, 114, 101, 109, 111, 118, 101]),
                        new Uint8Array([2, 24, 3]),
                        new Uint8Array([4, 50, 2, 105, 100]),
                    ],
                },
            },
        },
        /** Filters a post or comment by removing it from the user view and adding it to the mod queue. */
        filter: {
            name: "Filter",
            requestType: FilterRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {},
        },
        /** https://www.reddit.com/dev/api#POST_api_show_comment */
        showComment: {
            name: "ShowComment",
            requestType: BasicModerationIdRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            19,
                            18,
                            17,
                            47,
                            97,
                            112,
                            105,
                            47,
                            115,
                            104,
                            111,
                            119,
                            95,
                            99,
                            111,
                            109,
                            109,
                            101,
                            110,
                            116,
                        ]),
                        new Uint8Array([2, 24, 3]),
                        new Uint8Array([4, 50, 2, 105, 100]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_snooze_reports */
        snoozeReports: {
            name: "SnoozeReports",
            requestType: SnoozeReportsRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            21,
                            18,
                            19,
                            47,
                            97,
                            112,
                            105,
                            47,
                            115,
                            110,
                            111,
                            111,
                            122,
                            101,
                            95,
                            114,
                            101,
                            112,
                            111,
                            114,
                            116,
                            115,
                        ]),
                        new Uint8Array([2, 24, 3]),
                        new Uint8Array([4, 50, 2, 105, 100]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_unignore_reports */
        unignoreReports: {
            name: "UnignoreReports",
            requestType: BasicModerationIdRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            23,
                            18,
                            21,
                            47,
                            97,
                            112,
                            105,
                            47,
                            117,
                            110,
                            105,
                            103,
                            110,
                            111,
                            114,
                            101,
                            95,
                            114,
                            101,
                            112,
                            111,
                            114,
                            116,
                            115,
                        ]),
                        new Uint8Array([2, 24, 3]),
                        new Uint8Array([4, 50, 2, 105, 100]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_unmute_message_author */
        unmuteMessageAuthor: {
            name: "UnmuteMessageAuthor",
            requestType: BasicModerationIdRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            28,
                            18,
                            26,
                            47,
                            97,
                            112,
                            105,
                            47,
                            117,
                            110,
                            109,
                            117,
                            116,
                            101,
                            95,
                            109,
                            101,
                            115,
                            115,
                            97,
                            103,
                            101,
                            95,
                            97,
                            117,
                            116,
                            104,
                            111,
                            114,
                        ]),
                        new Uint8Array([2, 24, 3]),
                        new Uint8Array([4, 50, 2, 105, 100]),
                        new Uint8Array([2, 88, 1]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_unsnooze_reports */
        unsnoozeReports: {
            name: "UnsnoozeReports",
            requestType: SnoozeReportsRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            23,
                            18,
                            21,
                            47,
                            97,
                            112,
                            105,
                            47,
                            117,
                            110,
                            115,
                            110,
                            111,
                            111,
                            122,
                            101,
                            95,
                            114,
                            101,
                            112,
                            111,
                            114,
                            116,
                            115,
                        ]),
                        new Uint8Array([2, 24, 3]),
                        new Uint8Array([4, 50, 2, 105, 100]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_update_crowd_control_level */
        updateCrowdControlLevel: {
            name: "UpdateCrowdControlLevel",
            requestType: UpdateCrowdControlLevelRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            33,
                            18,
                            31,
                            47,
                            97,
                            112,
                            105,
                            47,
                            117,
                            112,
                            100,
                            97,
                            116,
                            101,
                            95,
                            99,
                            114,
                            111,
                            119,
                            100,
                            95,
                            99,
                            111,
                            110,
                            116,
                            114,
                            111,
                            108,
                            95,
                            108,
                            101,
                            118,
                            101,
                            108,
                        ]),
                        new Uint8Array([2, 24, 3]),
                        new Uint8Array([4, 50, 2, 105, 100]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_stylesheet */
        stylesheet: {
            name: "Stylesheet",
            requestType: StylesheetRequest,
            requestStream: false,
            responseType: StringValue,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            27,
                            18,
                            25,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            115,
                            116,
                            121,
                            108,
                            101,
                            115,
                            104,
                            101,
                            101,
                            116,
                        ]),
                        new Uint8Array([2, 64, 1]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
    },
};
